<template>
  <nav
    :class="{sidebar: true, sidebarStatic, sidebarOpened,'hidden-sm-down d-print-none' : true}"
    class="pb-3"
    style="padding-top: 50px;overflow-y:scroll;overflow-x:hidden;"
  >
    <ul class="nav mt-2">
      <NavLink
        v-if="typeof route.meta != 'undefined' && route.meta.affix == true  && $route.matched[0].path != '/settings'&&(route.meta.page != 'pricelists'||(route.meta.page == 'pricelists' && route.meta.action=='index'&&price_list.is_price_list_enabled))"
        v-for="(route,index) in permission_routes.children"
        :link="'/app/'+route.path"
        :key="index"
        :isHeader="route.meta.isheader"
        :header="route.meta.title"
        :iconName="route.meta.icon"
        index
        label
        :end="route.meta.end"
      />
      <NavLink
        class="goback-icon"
        v-if="$route.matched[0].path == '/settings'"
        :link="module_path"
        :isHeader="true"
        header="Go Back"
        iconName="fa fa-angle-left fa-lg"
        label
      />
      <!-- <router-link
        to="/app"
        v-if="$route.matched[0].path == '/settings'"
        class="text-decoration-none fw-semi-bold"
      >
        <span class="hoth-go-back head-hide text-white p-2">
          <i class="glyphicon glyphicon-chevron-left mr-3 mb-2 ml-2"></i>Go Back
        </span>
      </router-link>-->

      <NavLink
        v-if="typeof route.meta != 'undefined' && route.meta.affix == true && $route.matched[0].path == '/settings'"
        v-for="(route,index) in settings_routes.children "
        :link="'/settings/'+route.path"
        :key="index + 10"
        :isHeader="route.meta.isheader"
        :header="route.meta.title"
        :iconName="route.meta.icon"
        index
        label
        :end="route.meta.end"
      />
    </ul>
  </nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import isScreen from "@/core/screenHelper";
import NavLink from "./NavLink/NavLink";

export default {
  name: "Sidebar",
  components: { NavLink },

  methods: {
    ...mapActions("layout", ["changeSidebarActive", "switchSidebar"]),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split("/");
      paths.pop();
      this.changeSidebarActive(paths.join("/"));
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen("lg") || isScreen("xl"))) {
        this.switchSidebar(false);
        this.setActiveByRoute();
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen("lg") || isScreen("xl"))) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }
    }
  },
  created() {
    this.setActiveByRoute();
  },
  computed: {
    ...mapState({
      sidebarStatic: state => state.layout.sidebarStatic,
      sidebarOpened: state => !state.layout.sidebarClose,
      activeItem: state => state.layout.sidebarActiveElement,
      price_list: state => state.permission.price_list,
      module_path: state => state.general.module_path
    }),
    ...mapGetters(["permission_routes", "settings_routes"])
  }
};
</script>

<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped/>
